import { Box } from '@mui/material'

declare type PassengerSelectRowsProps = {
  main?: string
  description?: string | JSX.Element
}

const PassengerSelectRows = ({
  main,
  description,
}: PassengerSelectRowsProps) => {
  return (
    <Box
      component="div"
      sx={[
        {
          alignSelf: 'start',
          marginBottom: '0px',
        },
      ]}
    >
      {main && (
        <Box
          component="p"
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            // color: '#0a2435',
            textTransform: 'uppercase',
            marginBottom: '0px',
          }}
        >
          {main}
        </Box>
      )}
      {description && (
        <Box
          component="p"
          sx={{ fontWeight: 'light' }}
          //   sx={{ fontSize: '12px', fontWeight: 'light', color: '#414042' }}
        >
          {description}
        </Box>
      )}
    </Box>
  )
}

export default PassengerSelectRows
